module.exports = __webpack_public_path__ + "static/media/Path6.445864de.svg";